'use client';
import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { useT } from "../../i18n";
import { SectionKicker } from "./shared";

export function ActZero({ onComplete }: { onComplete: () => void }) {
  const t = useT();
  return (
    <motion.section
      className="act act-zero"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0, filter: "blur(8px)" }}
      transition={{ duration: 0.6 }}
    >
      <div className="act-bg" />
      <div className="shade" />
      <div className="grain" />

      <div className="act-content">
        <div className="hero-copy">
          <SectionKicker>{t('landlink.zero.kicker')}</SectionKicker>
          <h1>
            {t('landlink.zero.titleA')}<br />
            {t('landlink.zero.titleB')}
          </h1>
          <p className="body-text">
            {t('landlink.zero.body')}
            <strong>{t('landlink.zero.bodyStrong')}</strong>
          </p>
          <button className="cta-button" onClick={onComplete}>
            {t('landlink.zero.cta')} <ArrowRight size={22} />
          </button>
        </div>

        <div className="hero-visual" aria-hidden="true">
          <motion.div
            className="dash-card"
            initial={{ opacity: 0, x: 40 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ delay: 0.3, duration: 0.7 }}
          >
            <div className="dash-card-top">
              <i />
              <i />
              <i />
            </div>
            <div className="dash-bars">
              <b />
              <b />
              <b />
              <b />
              <b />
              <b />
            </div>
            <div className="dash-stat">
              <strong>63%</strong>
              <span>{t('landlink.zero.dashLabel')}</span>
            </div>
          </motion.div>
        </div>
      </div>
    </motion.section>
  );
}
